import { render, staticRenderFns } from "./TabbedWindowComponent.vue?vue&type=template&id=585e5028&scoped=true"
import script from "./TabbedWindowComponent.vue?vue&type=script&lang=js"
export * from "./TabbedWindowComponent.vue?vue&type=script&lang=js"
import style0 from "./TabbedWindowComponent.vue?vue&type=style&index=0&id=585e5028&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e5028",
  null
  
)

export default component.exports